import { render } from "./SubscriptinPtwo.vue?vue&type=template&id=5a0a40a5"
import script from "./SubscriptinPtwo.vue?vue&type=script&lang=js"
export * from "./SubscriptinPtwo.vue?vue&type=script&lang=js"

import "./SubscriptinPtwo.vue?vue&type=style&index=0&id=5a0a40a5&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__